import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';

import ConfirmationCard from '../../components/Shared/ConfirmationCardMultiActionsCard';
import TitleComponent from '../../components/Shared/TitleMultiActionsCard';
import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';
import { copyFor } from '../../copy/copy';

const BodyText = styled.span`
    color: #333;

    a {
        color: #ff245e;
        text-decoration: none;
    }
`;

const VolunteerInfoComponent = props => (
    <BodyText>
        <br />
        {props.error ? (
            copyFor('feedback', 'error', 'volunteer')
        ) : (
            <span>{copyFor('feedback', 'verifyEmail', 'volunteer')}</span>
        )}
    </BodyText>
);

VolunteerInfoComponent.propTypes = {
    error: PropTypes.bool
};

const VolunteerSuccessMultiActionCard = props => (
    <TransitionContainerNoExit>
        {props.volunteerActionCompleted ? (
            <ConfirmationCard
                thankYouText={`${props.numCompleted}`}
                titleComponent={
                    <TitleComponent
                        titleNoRep={copyFor('feedback', 'thanks', 'volunteer')}
                    />
                }
                bodyComponent={<VolunteerInfoComponent />}
            />
        ) : (
            <ConfirmationCard
                thankYouText=""
                titleComponent={
                    <TitleComponent
                        titleNoRep={`There was a problem completing your signup.`}
                    />
                }
                bodyComponent={<VolunteerInfoComponent error={true} />}
            />
        )}
    </TransitionContainerNoExit>
);

VolunteerSuccessMultiActionCard.propTypes = {
    volunteerActionCompleted: PropTypes.bool.isRequired,
    numCompleted: PropTypes.number.isRequired
};

export default connect(
    state => ({
        volunteerActionCompleted: state.volunteer.actionCompleted,
        numCompleted: state.volunteer.successData.counter || 51
    }),
    {}
)(VolunteerSuccessMultiActionCard);
